// The 2027-vision agents from the agentic-buying roadmap (the MVP doc's ideal
// end state). These are NOT live today — they are drawn on the orchestration web
// as dimmed, dashed "roadmap" nodes so the picture shows the full ambition while
// staying honest about what actually executes now. Keeping them in their own file
// makes the live/roadmap boundary a data property, not a rendering accident.

export interface RoadmapAgent {
  id: string;
  name: string;
  // The phase of the ideal end-state pipeline this agent belongs to.
  phase: 'pre-flight' | 'execution' | 'in-flight' | 'post-flight';
  // Who provides the agent in the 2027 vision. 'newton' agents are supplied by
  // the Newton (Bliss Point Audience + Planner) platform, so the web attributes
  // them to Newton rather than implying Tinuiti builds them. Omitted = Tinuiti/BPM.
  provider?: 'newton';
}

export const ROADMAP_AGENTS: RoadmapAgent[] = [
  // Pre-flight enrichment layer (parallel research agents feeding the plan).
  // NOTE: the "Relationship Analyzer" (which would mine Gong/Slack/Email/Salesforce
  // for the agency↔client relationship) is intentionally NOT surfaced — "we analyze
  // our relationship with you" is a recoil moment in front of a client/analyst.
  { id: 'company-analyzer', name: 'Company Analyzer', phase: 'pre-flight', provider: 'newton' },
  { id: 'prior-performance', name: 'Prior Performance Analysis', phase: 'pre-flight' },
  {
    id: 'cross-channel-planning',
    name: 'Cross-Channel Planning',
    phase: 'pre-flight',
    provider: 'newton'
  },
  { id: 'audience-planning', name: 'Audience Planning', phase: 'pre-flight', provider: 'newton' },
  { id: 'audience-finder', name: 'Audience Finder', phase: 'pre-flight', provider: 'newton' },
  { id: 'media-landscape', name: 'Media Landscape', phase: 'pre-flight', provider: 'newton' },
  { id: 'media-cost', name: 'Media Cost', phase: 'pre-flight' },
  { id: 'supply-path-efficacy', name: 'Supply Path Efficacy', phase: 'pre-flight' },
  { id: 'expected-performance', name: 'Expected Performance', phase: 'pre-flight' },
  { id: 'ideal-plan', name: 'Ideal Plan', phase: 'pre-flight' },
  { id: 'media-availability', name: 'Media Availability', phase: 'pre-flight' },
  { id: 'creative-readiness', name: 'Creative / Asset Readiness', phase: 'pre-flight' },
  { id: 'plan-build', name: 'Plan Build', phase: 'pre-flight' },
  // Execution + closed loop.
  { id: 'validation', name: 'Validation', phase: 'execution' },
  { id: 'monitoring', name: 'Monitoring', phase: 'in-flight' },
  { id: 'optimization', name: 'Optimization', phase: 'in-flight' },
  { id: 'results-ingestion', name: 'Results Ingestion', phase: 'post-flight' }
];
